function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { normalize } from './GridPagerSettings';
import { PagerNumericButtons } from './PagerNumericButtons';
import { PagerInput } from './PagerInput';
import { PagerPageSizes } from './PagerPageSizes';
import { messages, pagerFirstPage, pagerLastPage, pagerNextPage, pagerPreviousPage, pagerInfo } from '../messages';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
import { provideLocalizationService, provideIntlService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var Pager =
/** @class */
function (_super) {
  __extends(Pager, _super);

  function Pager() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Pager.prototype, "totalPages", {
    get: function get() {
      return Math.ceil((this.$props.total || 0) / this.$props.pageSize);
    },
    enumerable: true,
    configurable: true
  });

  Pager.prototype.changePage = function (page, e) {
    if (this.$props.pageChange && page > 0 && page <= this.totalPages) {
      this.$props.pageChange({
        skip: (page - 1) * this.$props.pageSize,
        take: this.$props.pageSize
      }, e);
    }
  };

  Object.defineProperty(Pager.prototype, "currentPage", {
    get: function get() {
      return Math.floor((this.$props.skip || 0) / this.$props.pageSize) + 1;
    },
    enumerable: true,
    configurable: true
  }); // @ts-ignore 

  Pager.prototype.render = function (h) {
    var _this = this;

    var settings = normalize(this.$props.settings);
    var localizationService = provideLocalizationService(this);
    var intlService = provideIntlService(this);

    var button = function button(page, className, title, icon) {
      return h("a", {
        on: {
          "click": function click(e) {
            e.preventDefault();

            _this.changePage(page, e);
          }
        },
        attrs: {
          href: "#",
          title: title
        },
        "class": className
      }, [h("span", {
        "class": icon,
        attrs: {
          "aria-label": title
        }
      })]);
    };

    var changer = settings.type === 'numeric' ? h(PagerNumericButtons, {
      attrs: {
        buttonCount: settings.buttonCount || 0,
        totalPages: this.totalPages,
        currentPage: this.currentPage,
        pageChange: this.changePage
      }
    }) : h(PagerInput, {
      attrs: {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        pageChange: this.changePage
      }
    });
    var first, prev, next, last;

    if (settings.previousNext) {
      first = button(1, 'k-link k-pager-nav k-pager-first' + (this.currentPage === 1 ? ' k-state-disabled' : ''), localizationService.toLanguageString(pagerFirstPage, messages[pagerFirstPage]), 'k-icon k-i-seek-w');
      prev = button(this.currentPage - 1, 'k-link k-pager-nav' + (this.currentPage === 1 ? ' k-state-disabled' : ''), localizationService.toLanguageString(pagerPreviousPage, messages[pagerPreviousPage]), 'k-icon k-i-arrow-w');
      next = button(this.currentPage + 1, 'k-link k-pager-nav' + (this.currentPage === this.totalPages ? ' k-state-disabled' : ''), localizationService.toLanguageString(pagerNextPage, messages[pagerNextPage]), 'k-icon k-i-arrow-e');
      last = button(this.totalPages, 'k-link k-pager-nav k-pager-last' + (this.currentPage === this.totalPages ? ' k-state-disabled' : ''), localizationService.toLanguageString(pagerLastPage, messages[pagerLastPage]), 'k-icon k-i-seek-e');
    }

    var pageSizes = settings.pageSizes !== false && h(PagerPageSizes, {
      attrs: {
        pageChange: this.$props.pageChange,
        pageSize: this.$props.pageSize,
        pageSizes: settings.pageSizes
      }
    });
    var defaultMessage = messages[pagerInfo];
    var info = !settings.info ? '' : h("div", {
      "class": "k-pager-info k-label"
    }, [intlService.format(localizationService.toLanguageString(pagerInfo, defaultMessage), [Math.min(this.$props.skip + 1, this.$props.total), Math.min(this.$props.skip + this.$props.pageSize, this.$props.total), this.$props.total])]);
    return h("div", {
      "class": "k-pager-wrap k-grid-pager k-widget"
    }, [first, prev, changer, next, last, pageSizes, info]);
  };

  Pager = __decorate([Component({
    props: {
      total: Number,
      skip: Number,
      pageSize: Number,
      settings: [Object, Boolean],
      pageChange: Function,
      render: Function
    },
    inject: {
      kendoLocalizationService: {
        default: null
      },
      kendoIntlService: {
        default: null
      }
    }
  })], Pager);
  return Pager;
}(VueComponent);

export { Pager }; // registerForIntl(Pager);
// registerForLocalization(Pager);